import { useCallback } from "react";
import { SidePanelDS } from "@qivia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useAppSelector } from "../../../../redux/hooks";
import { selectElectricCharges } from "../electricChargingSlice";
import { SidePanelHeader } from "./sidePanelHeader";
import "../../../../i18n/i18n";

export const ChargingSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const electricCharges = useAppSelector(selectElectricCharges);

  const charge = electricCharges.find((c) => c.uuid === params.id) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/charging_tracking`);
  }, [firstPath, navigate]);

  if (!charge) {
    return;
  }

  return (
    <SidePanelDS.SidePanel visible={!!charge} onClose={onSidePanelClosed}>
      <SidePanelDS.Section
        verticalSpacing={1.5}
        horizontalSpacing={1.5}
        background={colors["colors/button/secondary/hover"]}
      >
        <SidePanelHeader charge={charge} />
      </SidePanelDS.Section>
    </SidePanelDS.SidePanel>
  );
};
